import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CDN_ROUTES } from '@bn/dashboard-core/constants';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { RouteUtils } from '@bn/shared/utils';
import { AppShieldEventLogsStore, ShieldApiStore } from '../../stores';

@Component({
  templateUrl: './manage-app-shield.page.html',
  styleUrls: ['./manage-app-shield.page.scss'],
  imports: [RouterModule],
  providers: [AppShieldEventLogsStore],
})
export class ManageAppShieldPage extends AbstractLazyDirective {
  readonly #shieldApiStore = inject(ShieldApiStore);

  constructor() {
    super();

    this.#shieldApiStore.getShieldDefaults();

    effect(() => {
      const isSetupRequired = this.#shieldApiStore.setupRequired();
      if (isSetupRequired === undefined || isSetupRequired === null) return;

      // If setup is required and route is not setup redirect user to setup
      if (isSetupRequired && !RouteUtils.isDataPropertyActiveInChildPages(this.route, 'isShieldSetupPage')) {
        this.router.navigate([CDN_ROUTES.ShieldSetup], {
          queryParams: { step: 1 },
          relativeTo: this.route,
        });

        return;
      }

      // If setup is not required and user lands on setup redirect to overview
      if (!isSetupRequired && RouteUtils.isDataPropertyActiveInChildPages(this.route, 'isShieldSetupPage')) {
        this.router.navigate([CDN_ROUTES.ShieldOverview], { relativeTo: this.route });
      }
    });
  }
}
